import { render, staticRenderFns } from "./home-fotor2.vue?vue&type=template&id=33846cfc&scoped=true"
import script from "./home-fotor2.vue?vue&type=script&lang=ts"
export * from "./home-fotor2.vue?vue&type=script&lang=ts"
import style0 from "./home-fotor2.vue?vue&type=style&index=0&id=33846cfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33846cfc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OpenInBrowser: require('/root/builds/ASbHBz4D/0/fotor-mobile/frontend/fotor-h5-website/components/common/OpenInBrowser.vue').default})
